import { render, staticRenderFns } from "./b2bLogin.vue?vue&type=template&id=90723ece&scoped=true&"
import script from "./b2bLogin.vue?vue&type=script&lang=js&"
export * from "./b2bLogin.vue?vue&type=script&lang=js&"
import style0 from "./b2bLogin.vue?vue&type=style&index=0&id=90723ece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90723ece",
  null
  
)

export default component.exports